// extracted by mini-css-extract-plugin
export default {"error":"Uploading_error__JB1Uj","icon":"Uploading_icon__tEaQj","wrapper":"Uploading_wrapper__ufqGm","button":"Uploading_button__o2nFy"};